import S from 'common/service/sanctuary';
import { compose } from 'ramda';
import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import Button from 'common/mdc/button';
import { StepperContent } from 'common/mdc/stepper';
import Form, { Error, DisplayField } from "common/mdc/form/index";
import TextField from "common/mdc/textfield/index";
import RadioField from 'common/mdc/form/radio';
import DatetimeInput from 'common/mdc/form/datetime';
import { actions } from "@sma/store/job/jobs";
import Icon from 'common/mdc/icon';
import { scheduleGetTypeJob } from '../../../../utils';

export const STEP_ID = Symbol('refine-selection');

const messages = defineMessages({
  title: {
    id: 'jobCreate.title.step4',
    defaultMessage: 'Schedule',
  },
  preview: {
    id: 'jobCreate.actions.preview',
    defaultMessage: 'preview',
  },
  runJob: {
    id: 'jobCreate.actions.runJob',
    defaultMessage: 'Run Job',
  },
});

export const title = <FormattedMessage {...messages.title} />;

class Step4 extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isActive: true,
      timeout: null,
    };

    this.setActive = this.setActive.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleRunJob = this.handleRunJob.bind(this);

  }

  componentDidMount() {
    const { isActive, timeout, } = this.props.newJobEntries || {};
    this.setState({
      isActive,
      timeout,
    });
  }

  setActive (value) {
    const { saveStep4Details } = this.props;
    this.setState({
      isActive: value,
    },()=>{
      saveStep4Details({ isActive: value, });
    });
  }

  handleDateChange(date) {
    const { saveStep4Details } = this.props;
    if(date === undefined || date === null ) {
      this.setState({
        timeout: null
      },()=>{
        saveStep4Details({ timeout: null, })
      });
      return;
    }
    this.setState({
        timeout: date
    },()=>{
      saveStep4Details({ timeout: date, })
    });
  }

  handleRunJob() {
    scheduleGetTypeJob(this.props.newJobEntries, this.props.runGetJob);
  }

  render() {
    const {

      stepper,
      cancelAction,
      showPreviewJobDialog,

    } = this.props;

    const { isActive, timeout } = this.state;

    return (
      <StepperContent
        loading={false}
        onSubmit={()=>{}}
        title={title}
        actions={[
          cancelAction,
          <Button raised onClick={()=>showPreviewJobDialog(true)}>
            <FormattedMessage {...messages.preview} />
          </Button>,
          <Button raised onClick={()=>this.handleRunJob()}>
            <FormattedMessage {...messages.runJob} />
          </Button>,
        ]}
        className="job-schedule-form-container"
      >
        <Form className={"create-job-form"}>
          <div className='active-select-container'>
            <DisplayField label={"ACTIVE"} isRequired>
              <RadioField
                id={"active-true"}
                checked={isActive == true}
                onChange={() => this.setActive(true)}
                label={"True"}
              />
              <Icon
                className={"md-dark info-icon"}
                title={'Retrieves the configuration currently active and being used by the meter.'}
              >
                {"info"}
              </Icon>
              <RadioField
                id={"active-false"}
                checked={isActive == false}
                onChange={() => this.setActive(false)}
                label={"False"}
              />
              <Icon
                className={"md-dark info-icon"}
                title={'Retrieves the pending/passive configuration that is scheduled to become active in the future (if supported by the meter).'}
              >
                {"info"}
              </Icon>
            </DisplayField>
          </div>
          <div className='timeout-input-container'>
            <DisplayField label={"Timeout Date & Time"}>
              <DatetimeInput value={timeout} onChange={(date) => this.handleDateChange(date)}/>
            </DisplayField>
            <i className="timeout-note">If not specified, the default timeout will apply. If the entered value exceeds the allowed maximum, the default timeout will be used.</i>
          </div>
        </Form>

      </StepperContent>
    );
  }
}

Step4.defaultProps = {
  newJobEntries: {},
};

export default compose(
  connect(
    state => ({
      newJobEntries: state.job.jobs.createJob
    }),
    {
      saveStep4Details: actions.saveStep4Details,
      runGetJob: actions.runGetJob,
      showPreviewJobDialog: actions.showPreviewJobDialog,
    },
  ),
  injectIntl,
)(Step4);
